import Auth from '@/Libs/Api/Panel/Auth.js'
import User from '@/Libs/Api/Panel/User.js'
import Store from '@/Libs/Api/Panel/Store.js'
import Branch from '@/Libs/Api/Panel/Branch.js'
import Employee from '@/Libs/Api/Panel/Employee.js'
import Reservation from '@/Libs/Api/Panel/Reservation.js'
import Room from '@/Libs/Api/Panel/Room.js'
import OpenHour from '@/Libs/Api/Panel/OpenHour.js'
import SpecialDay from '@/Libs/Api/Panel/SpecialDay.js'
import Day from '@/Libs/Api/Panel/Day.js'
import Stuff from '@/Libs/Api/Panel/Stuff.js'
import StuffType from '@/Libs/Api/Panel/StuffType.js'
import Category from '@/Libs/Api/Panel/Category.js'
import EmailTemplate from '@/Libs/Api/Panel/EmailTemplate.js'
import BranchSession from '@/Libs/Api/Panel/BranchSession.js'
import StuffAvailable from '@/Libs/Api/Panel/StuffAvailable.js'
import ConfigStore from '@/Libs/Api/Panel/ConfigStore.js'
import ConfigReservation from '@/Libs/Api/Panel/ConfigReservation.js'
import ConfigUser from '@/Libs/Api/Panel/ConfigUser.js'
import ConfigStuff from '@/Libs/Api/Panel/ConfigStuff.js'
import PermissionGroup from '@/Libs/Api/Panel/PermissionGroup.js'
import Permission from '@/Libs/Api/Panel/Permission.js'
import Dashboard from '@/Libs/Api/Panel/Dashboard.js'

import EmployeeInvite from '@/Libs/Api/Public/EmployeeInvite.js'

export default function Api($http, $cookie) {
    this.$cookie = $cookie

    this.setApiToken = function (api_token) {
        $cookie.set('api_token', api_token, {
            path: '/',
        })
    }

    this.unsetApiToken = function () {
        $cookie.remove('api_token', {
            path: '/',
        })
    }

    this.getApiToken = function () {
        return $cookie.get('api_token')
    }

    //library for api call
    this.get = function (url) {
        var _apiToken = this.getApiToken()

        return $http.get(url, {
            headers: { 'Authorization': 'Bearer ' + _apiToken }
        })
    }

    this.post = function (url, data) {
        var _apiToken = this.getApiToken()

        var postData = JSON.stringify(data)

        return $http({
            method: 'POST',
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _apiToken
            },
            data: postData
        })
    }

    this.upload = function (url, data) {
        var _apiToken = this.getApiToken()

        var formData = new FormData()
        formData.append('file', data)

        return $http({
            method: 'POST',
            url: url,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + _apiToken
            },
            data: formData
        })
    }

    this.delete = function (url) {
        var _apiToken = this.getApiToken()

        return $http.delete(url, {
            headers: { 'Authorization': 'Bearer ' + _apiToken }
        })
    }

    this.Public = {
        post: function (url, data) {
            var postData = JSON.stringify(data)

            return $http({
                method: 'POST',
                url: url,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: postData
            })
        }
    }

    this.Auth = new Auth(this)
    this.User = new User(this)
    this.Store = new Store(this)
    this.Branch = new Branch(this)
    this.Employee = new Employee(this)
    this.Reservation = new Reservation(this)
    this.Room = new Room(this)
    this.OpenHour = new OpenHour(this)
    this.SpecialDay = new SpecialDay(this)
    this.Day = new Day(this)
    this.Stuff = new Stuff(this)
    this.StuffType = new StuffType(this)
    this.Category = new Category(this)
    this.EmployeeInvite = new EmployeeInvite(this)
    this.EmailTemplate = new EmailTemplate(this)
    this.BranchSession = new BranchSession(this)
    this.StuffAvailable = new StuffAvailable(this)
    this.ConfigStore = new ConfigStore(this)
    this.ConfigReservation = new ConfigReservation(this)
    this.ConfigUser = new ConfigUser(this)
    this.ConfigStuff = new ConfigStuff(this)
    this.PermissionGroup = new PermissionGroup(this)
    this.Permission = new Permission(this)
    this.Dashboard = new Dashboard(this)
}